import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import * as serviceWorker from './serviceWorker';

// Firebase is now lazily loaded via src/utils/firebase.ts
// This defers ~50KB of JavaScript until analytics is needed

// Render main App component using React 18 createRoot API
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// Register service worker
serviceWorker.register();
